import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { isFacilityLike } from "routes/schedule/my-schedules/my-group-types/space/is-facility-like.js"

export function getFacilityProfileScheduleRoute({ stats, schedule, share }) {
    const route = `/app/facilities/schedule/${stats.id}`
    const searchParams = new URLSearchParams()

    if (schedule?.version) {
        searchParams.set("version", schedule.version)
    }

    if (share !== null) {
        searchParams.set("share", share)
    }

    return appendSearchParams(route, searchParams)
}

export function getRegimeRoute({ regimeId, nodeId, share }) {
    const searchParams = new URLSearchParams()

    if (share !== null) {
        searchParams.set("share", share)
    }

    searchParams.set("id", nodeId)

    return appendSearchParams(`/app/facilities/${regimeId}`, searchParams)
}

export function getFacilityProfileNavigatorRoute({ item, share }) {
    const route = getFacilityRoute(item)
    const searchParams = new URLSearchParams()

    if (share !== null) {
        searchParams.set("share", share)
    }

    return appendSearchParams(route, searchParams)
}

function getFacilityRoute(item) {
    if (!item) return "/app/facilities"

    if (item[PlanRoot]) {
        return `/app/facilities/${item.id}`
    }

    if (isFacilityLike(item)) {
        return `/app/facilities/facility/${item.id}`
    }

    if (item.data?.type === "space" || item.type === "group") {
        const facility = parentFind(item, (parent) => isFacilityLike(parent))
        if (facility) {
            return `/app/facilities/facility/${facility.id}/${item.id}`
        }
    }

    return `/app/facilities/facility/${item.id}`
}

function appendSearchParams(route, searchParams) {
    const search = searchParams.toString()
    if (!search) return route
    return `${route}?${search}`
}
